import { render, staticRenderFns } from "./Chooser.vue?vue&type=template&id=3a4dc748&scoped=true"
import script from "./Chooser.vue?vue&type=script&lang=js"
export * from "./Chooser.vue?vue&type=script&lang=js"
import style0 from "./Chooser.vue?vue&type=style&index=0&id=3a4dc748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4dc748",
  null
  
)

export default component.exports